module.exports = {
    Fair: 0,
    Up: 1,
    Down: 2
};